import React, { useEffect } from 'react';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    // Cal.com inline embed initialization
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    window.Cal("init", "30min", { origin: "https://app.cal.com" });

    window.Cal.ns["30min"]("inline", {
      elementOrSelector: "#my-cal-inline",
      config: { layout: "month_view" },
      calLink: "autometa-llc-uqokhv/30min",
    });

    window.Cal.ns["30min"]("ui", {
      cssVarsPerTheme: {
        light: { "cal-brand": "#0F766E" },
        dark: { "cal-brand": "#14B8A6" }
      },
      hideEventTypeDetails: false,
      layout: "month_view"
    });
  }, []);

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">
          Ready to Transform Your Business?
        </h2>
        <p className="contact-subtitle">
          Book a free consultation. Our team will understand your needs and recommend the perfect AI solution for your business.
        </p>
        <div className="cal-embed-wrapper">
          <div id="my-cal-inline"></div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
